import React from "react";
import LegalLayout from "./_LegalLayout";

const Disclaimer = () => (
  <LegalLayout
    testId="page-disclaimer"
    overline="Legal · Disclaimer"
    title="Disclaimer"
    lead="Allinstra is an institutional systems brand by Erenown."
  >
    <p className="text-sm text-ink-500">Effective date: 16 April 2026 · Last updated: 16 April 2026</p>

    <p>
      This website is intended to present structured information about institutional systems,
      municipal and public-service systems, industrial zone systems, document and records
      management, finance and revenue workflows, technology foundations, integrations,
      implementation pathways, and market adaptation.
    </p>

    <p>
      Nothing on this website should be interpreted as legal advice, tax advice, accounting
      advice, regulatory assurance, public procurement advice, financial advice, investment
      advice, technical guarantee, integration guarantee, or a guarantee of registration,
      approval, licensing, implementation, financing, public-system access, or business
      success.
    </p>

    <p>
      Any product description, module description, integration pathway, institutional
      discussion, implementation route, or market adaptation described on the website remains
      subject to separate review, jurisdiction-specific requirements, public infrastructure
      availability, third-party access, technical feasibility, and separate agreement where
      applicable.
    </p>
  </LegalLayout>
);

export default Disclaimer;
